import PropTypes from "prop-types"
import { formatLongDate } from "helpers/formatters/dates"
import { CHART_ITEM, OPTIONAL_CHART_ITEM } from "helpers/shapes"
import SelectedTooltipItem from "components/charts/selected-tooltip-item"
import { percentageFormatter, numberFormatter } from "helpers/formatters/numbers"

function FactorProfileTooltip({ id, datum, performanceHistory, normalizedHistory, predictiveRisk }) {
  if (datum) {
    return <div>
      <div className="header">{formatLongDate(datum.date)}</div>
      <SelectedTooltipItem id="return" currentId={id} data={performanceHistory} index={datum.index} formatter={percentageFormatter} label="Cumulative Return" />
      <SelectedTooltipItem id="normalized" currentId={id} data={normalizedHistory} index={datum.index} formatter={numberFormatter} label="Normalized Return" />
      {predictiveRisk && <SelectedTooltipItem id="risk" currentId={id} data={predictiveRisk} index={datum.index} formatter={percentageFormatter} label="Predictive Risk" />}
    </div>
  } else {
    return null
  }
}

FactorProfileTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  datum: CHART_ITEM,
  performanceHistory: PropTypes.arrayOf(CHART_ITEM).isRequired,
  normalizedHistory: PropTypes.arrayOf(OPTIONAL_CHART_ITEM).isRequired,
  predictiveRisk: PropTypes.arrayOf(CHART_ITEM),
}

export default FactorProfileTooltip
